package com.loyola.acessoescola.ui.navigation

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.toRoute
import com.loyola.acessoescola.ui.addnew.AddNewScreen
import com.loyola.acessoescola.ui.addnew.AddNewViewModel
import com.loyola.acessoescola.ui.addnew.HintScreen
import com.loyola.acessoescola.ui.adminpanel.AdminPanelScreen
import com.loyola.acessoescola.ui.adminpanel.AdminPanelViewModel
import com.loyola.acessoescola.ui.login.LoginScreen
import com.loyola.acessoescola.ui.login.LoginViewModel
import com.loyola.acessoescola.ui.policy.PolicyScreen
import com.loyola.acessoescola.ui.registered.RegisteredScreen
import com.loyola.acessoescola.ui.registered.RegisteredViewModel

@Composable
fun NavGraph(
    registeredViewModel: RegisteredViewModel,
    loginViewModel: LoginViewModel,
    navController: NavHostController,
    addNewViewModel: AddNewViewModel,
    adminPanelViewModel: AdminPanelViewModel,
    paddingValues: PaddingValues
){

    NavHost(
        navController = navController,
        startDestination=LoginDest
    ){
        composable<LoginDest>{
            LoginScreen(
                paddingValues = paddingValues,
                viewModel=loginViewModel,
                navToRegistered = {
                    navController.navigate(RegisteredDest){
                        popUpTo(LoginDest){inclusive = true}
                    }
                },
                navToPolicy = {navController.navigate(PolicyScreenDest)},
                navToAdminPanel = {navController.navigate(AdminPanelDest)}
            )
        }
        composable<RegisteredDest> {
            RegisteredScreen(
                paddingValues = paddingValues,
                registeredViewModel = registeredViewModel,
                navToHintScreen = {
                    navController.navigate(HintScreenDest)
                },
                navToEditRecord = { recordID -> navController.navigate(AddNewDest(recordID)) },
                navToPolicy = {navController.navigate(PolicyScreenDest)}
            )
        }

        composable<HintScreenDest> {
            HintScreen(
                paddingValues = paddingValues,
                navToAddNewScreen = {
                    navController.navigate(AddNewDest())
                }
            )
        }

        composable<AddNewDest> { backStackEntry ->
            val addNewDest: AddNewDest = backStackEntry.toRoute()
            AddNewScreen(
                paddingValues = paddingValues,
                addNewViewModel = addNewViewModel,
                navigateToRegistered = {
                    navController.navigate(RegisteredDest){
                        popUpTo(RegisteredDest){inclusive = true}
                    }
                },
                activeRecordID = addNewDest.recordID
            )
        }

        composable<PolicyScreenDest> {
            PolicyScreen(
                paddingValues = paddingValues,
                navigateBack = { navController.popBackStack() }
            )
        }

        composable<AdminPanelDest>{
            AdminPanelScreen(
                paddingValues=paddingValues,
                viewModel=adminPanelViewModel
            )
        }
    }
}